import React, { useState } from "react"
import "react-super-responsive-table/dist/SuperResponsiveTableStyle.css"
import { useDispatch, useSelector } from "react-redux"
import DataTable from "react-data-table-component"
import UserDetailModal from "./userDetailModal"
import { USER_TYPE } from "constants/common"
import { getAllUser } from "store/actions"

const PartnerList = () => {
  const dispatch = useDispatch()

  let partnerList = useSelector(state => state.Users.partners.users)
  let page = useSelector(state => state.Users.partners.page)

  const [selectedUser, setSelectedUser] = useState(null)
  const [userDetailModal, setUserDetailModal] = useState(false)
  const [perPage, setPerPage] = useState(10)

  const handlePageChange = page => {
    dispatch(
      getAllUser({
        type: USER_TYPE.PARTNER,
        page,
        size: perPage,
      })
    )
  }

  const handlePerRowsChange = (newPerPage, page) => {
    dispatch(
      getAllUser({
        type: USER_TYPE.PARTNER,
        page,
        size: newPerPage,
      })
    )
    setPerPage(newPerPage)
  }

  const columns = [
    {
      id: 1,
      name: "Name",
      selector: row => row.firstName,
      sortable: true,
      reorder: true,
      cell: row => (
        <div style={{ cursor: "pointer" }}>
          <span>
            {row.firstName} {row.lastName}
          </span>
          &nbsp;
          <i
            className="bx bx-info-circle text-primary"
            onClick={() => {
              setSelectedUser(row)
              setUserDetailModal(true)
            }}
          ></i>
        </div>
      ),
    },
    {
      id: 2,
      name: "Contact No.",
      selector: row => row.mobileNumber,
      sortable: true,
      reorder: true,
    },
    {
      id: 3,
      name: "Email",
      selector: row => row.email,
      sortable: true,
      // right: true,
      reorder: true,
    },
  ]

  return (
    <React.Fragment>
      <DataTable
        noHeader
        // title="Senior Citizen"
        columns={columns}
        data={partnerList}
        defaultSortFieldId={1}
        // sortIcon={<SortIcon />}
        pagination
        highlightOnHover
        // selectableRows
        paginationServer
        paginationTotalRows={page?.totalElements || 10}
        onChangePage={handlePageChange}
        onChangeRowsPerPage={handlePerRowsChange}
      />
      {selectedUser && (
        <UserDetailModal
          isOpen={userDetailModal}
          data={selectedUser}
          closeModal={() => {
            setUserDetailModal(false)
          }}
        ></UserDetailModal>
      )}
    </React.Fragment>
  )
}

export default PartnerList
